/*
 * file: app.js
 * description: it can contains application specific javascript code
*/

// local common.js - DO NOT REMOVE THIS IMPORT unless you're absolutely sure
import 'common.js'

// Application specific javascript starts from here



// WEBPACK FOOTER //
// ./public/javascripts/app.js